import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiUser, FiMail, FiPhone, FiBriefcase } = FiIcons;

const RegistrationModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    business: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const WEBHOOK_URL = 'https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjcwNTZjMDYzNzA0M2Q1MjZkNTUzNjUxMzAi_pc';

    try {
      // Send data to Pabbly Webhook
      await fetch(WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors', // Standard for many webhooks to avoid CORS issues if they don't return headers
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          event_type: 'form_submission',
          source: 'Tamil Business Landing Page',
          timestamp: new Date().toISOString(),
          page_url: window.location.href
        }),
      });

      // Show success state
      setIsSubmitting(false);
      setIsSubmitted(true);
      
      // Redirect to WhatsApp Community after a short delay
      setTimeout(() => {
        window.location.href = 'https://chat.whatsapp.com/Dsd7ttU8kCL6DlkVnZVuqr';
      }, 1500);

    } catch (error) {
      console.error('Submission error:', error);
      // Even if webhook fails, we want the user to proceed to WhatsApp
      setIsSubmitting(false);
      setIsSubmitted(true);
      setTimeout(() => {
        window.location.href = 'https://chat.whatsapp.com/Dsd7ttU8kCL6DlkVnZVuqr';
      }, 1000);
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
          />
          
          {/* Modal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-8 w-full max-w-md shadow-2xl border border-blue-500/30"
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
            >
              <SafeIcon icon={FiX} className="text-2xl" />
            </button>

            {!isSubmitted ? (
              <>
                {/* Header */}
                <div className="text-center mb-8">
                  <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                    FREE LIVE Workshop-ல Join ஆகுங்க!
                  </h3>
                  <p className="text-gray-300">
                    உங்க details fill பண்ணி registration complete பண்ணுங்க
                  </p>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-6">
                  {/* Name Field */}
                  <div>
                    <label className="block text-gray-300 font-medium mb-2">
                      பெயர் *
                    </label>
                    <div className="relative">
                      <SafeIcon icon={FiUser} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-4 py-3 bg-slate-700/50 border border-slate-600 rounded-lg text-white placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all"
                        placeholder="உங்க பெயரை enter பண்ணுங்க"
                      />
                    </div>
                  </div>

                  {/* Email Field */}
                  <div>
                    <label className="block text-gray-300 font-medium mb-2">
                      Email *
                    </label>
                    <div className="relative">
                      <SafeIcon icon={FiMail} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-4 py-3 bg-slate-700/50 border border-slate-600 rounded-lg text-white placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all"
                        placeholder="example@gmail.com"
                      />
                    </div>
                  </div>

                  {/* Phone Field */}
                  <div>
                    <label className="block text-gray-300 font-medium mb-2">
                      Mobile Number *
                    </label>
                    <div className="relative">
                      <SafeIcon icon={FiPhone} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-4 py-3 bg-slate-700/50 border border-slate-600 rounded-lg text-white placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all"
                        placeholder="9876543210"
                      />
                    </div>
                  </div>

                  {/* Business Type Field */}
                  <div>
                    <label className="block text-gray-300 font-medium mb-2">
                      தொழில் / Business Type *
                    </label>
                    <div className="relative">
                      <SafeIcon icon={FiBriefcase} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                      <select
                        name="business"
                        value={formData.business}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-4 py-3 bg-slate-700/50 border border-slate-600 rounded-lg text-white focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all appearance-none"
                      >
                        <option value="">Select your business type</option>
                        <option value="retail">Retail Business</option>
                        <option value="services">Service Provider</option>
                        <option value="coaching">Coach/Trainer</option>
                        <option value="consultant">Consultant</option>
                        <option value="ecommerce">E-commerce</option>
                        <option value="restaurant">Restaurant/Food</option>
                        <option value="manufacturing">Manufacturing</option>
                        <option value="freelancer">Freelancer</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 disabled:from-gray-600 disabled:to-gray-700 text-white py-4 rounded-lg font-bold text-lg transition-all duration-300 transform hover:scale-105 disabled:scale-100 shadow-xl"
                  >
                    {isSubmitting ? (
                      <div className="flex items-center justify-center gap-2">
                        <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                        Processing...
                      </div>
                    ) : (
                      '🔴 FREE Registration Complete பண்ணுங்க'
                    )}
                  </button>

                  <p className="text-xs text-gray-400 text-center">
                    Registration பண்ணினா, workshop details உங்க WhatsApp & Email-ல வரும்
                  </p>
                </form>
              </>
            ) : (
              /* Success & Redirect Message */
              <div className="text-center py-12">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="text-7xl mb-6"
                >
                  🎉
                </motion.div>
                <h3 className="text-2xl font-bold text-green-400 mb-4">
                  Registration Success!
                </h3>
                <p className="text-gray-300 mb-6">
                  Workshop details உங்க WhatsApp-க்கு send பண்ணிட்டோம்.
                </p>
                <div className="bg-blue-900/40 p-4 rounded-xl border border-blue-500/30">
                  <p className="text-white font-medium mb-2">Redirecting to WhatsApp Community...</p>
                  <div className="w-full bg-gray-700 h-1.5 rounded-full overflow-hidden">
                    <motion.div 
                      initial={{ width: 0 }}
                      animate={{ width: "100%" }}
                      transition={{ duration: 1.5 }}
                      className="bg-green-500 h-full"
                    />
                  </div>
                </div>
              </div>
            )}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default RegistrationModal;